const metrics = {
  drawerWidth: 295,
  sideBarDropdownWidth: 250,
  contentGridMaxWidthXl: {
    home: 1600,
    general: 1800,
  },
  breakpoints: {
    xs: 0,
    sm: 450,
    md: 850,
    lg: 1200,
    xl: 1920,
  },
  controllersAddToLg: 275,
  minWidth: 330,
  widgetMinHeight: 330,
  tableWidth: {
    medium: 625,
    small: 480,
    tiny: 385,
  },
  buttonsRow: {
    small: 445,
  },
  formDetails: {
    small: 480,
  },
  oneColumn: 480,
  auditHeaderColumns: {
    three: 800,
    between: 600,
    two: 400
  }
};

export default metrics;
